import React from 'react';

// Puedes definir tus estilos aquí o en un archivo CSS
const spinnerStyle = {
    border: '4px solid #f3f3f3', /* Color base */
    borderTop: '4px solid #a58d70', /* Color dorado/principal */
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    animation: 'spin 1s linear infinite',
    margin: '20px auto', // Centrarlo
};

// Se recomienda usar CSS para la animación, pero para simplicidad, la incluimos aquí
// Si usas un archivo CSS, quita la etiqueta <style> y añade las reglas a tu CSS global
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}`;
document.head.appendChild(styleSheet);


/**
 * Un spinner de carga simple.
 * @param {object} props - Propiedades.
 * @param {string} props.message - Mensaje opcional a mostrar debajo del spinner.
 * @param {boolean} props.fullScreen - Centrarlo en toda la pantalla (min-height
 *   en vh, que no depende de que el contenedor padre tenga una altura
 *   definida). Sin esto, un height:75% no tiene "75% de qué" si el padre no
 *   define altura (p. ej. .historia-container, solo max-width/flex) y el
 *   spinner queda pegado arriba en vez de centrado. Usar en pantallas
 *   completas de carga; dejar el default para spinners chicos/inline (como
 *   el del formulario de pago en Carrito).
 */
const LoadingSpinner = ({ message, fullScreen }) => (
    <div style={{
        textAlign: 'center',
        // Sin width:100%, un padre flex (ej. .detalle-evento-contenido, que
        // usa justify-content:space-between para su layout de dos columnas
        // ya cargado) achica este div a su propio contenido y lo deja
        // pegado a un costado en vez de centrado: el centrado interno de
        // acá abajo no tiene ancho completo sobre el que centrar.
        ...(fullScreen ? { minHeight: '80vh', width: '100%' } : { height: '75%' }),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    }}>
        <div style={spinnerStyle}></div>
        {message && <p style={{ marginTop: '10px', color: '#a58d70', fontWeight: 'bold' }}>{message}</p>}
    </div>
);

export default LoadingSpinner;